import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Grid, { Cell } from '@dbk/ui-grid';
import { Sort, ArrowRight, Info2 } from '@dbk/ui-icons';
import Text, { H2 } from '@dbk/ui-text';
import { FormattedMessage } from '@dbk-legacy/format';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import { Currency } from '../../../components/common/number';
import Popover from '@dbk/ui-popover';
import styles from './summary-cash-accounts-grid.styles';
import { PALETTE, CASH_ACCOUNTS_CONSTANTS, ROUTES } from '../../../constants';
import Button from '@dbk/ui-buttons';
import PaymentSelection from '../../../screens/payments/init-payments/payment-selection/index.js'
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import { Dimensions } from 'react-native';
import labelForPFid from '../../../utils/portfolio-number-aria-label';
/* Top column header and corresponding labels */
const SUMMARY_LIST_COLUMNS = [
  { columnValue: CASH_ACCOUNTS_CONSTANTS.NAME, columnLabel: 'app.trade.label.cashAccount', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.IBAN, columnLabel: 'app.cashAccounts.label.iban', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.ACCOUNT, columnLabel: 'app.dashboard.summaryData.accountName.label', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.PF_ID, columnLabel: 'app.dashboard.summaryData.portfolioId.label', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.PF_TYPE, columnLabel: 'app.dashboard.summaryData.accountType.label', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.BALANCE, columnLabel: 'app.cashAccounts.label.currentBalance', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.ARROW, columnLabel: '', subHead: '' },
  { columnValue: CASH_ACCOUNTS_CONSTANTS.NEW_PAYMENT, columnLabel: '', subHead: '' },
];

class SummaryCashAccountsGrid extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sortedColumnIndex: props.sortedColumnIndex,
      sortedDirection: props.sortedDirection,
      sortedRows: props.cashAccSummary.cashAccList,
      selectedRowIndex: -1,
    }

    this.cashSummaryDetails = this.cashSummaryDetails.bind(this);
  }

  componentWillUpdate() {
    this.grid.forceUpdateGrid();
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({sortedRows: nextProps.cashAccSummary.cashAccList});
    this.setState({sortedColumnIndex: -1, sortedDirection: 0});
  }

  componentWillUnmount = () => {
    this.props.onSortChange(this.state.sortedColumnIndex, this.state.sortedDirection);
  }

  componentDidMount = () => {
   // const item=this.pfDetailsWithBpNameHandler();
    this.props.payments.setIsCashPaymentFlow(false);
    if(this.state.sortedDirection !== 0){
      const sortColumn = this.getColumnByIndex(this.state.sortedColumnIndex);
      let sortedRows = sortColumn ? sortBy(this.state.sortedRows, sortColumn) : this.state.sortedRows;
      if (this.state.sortedDirection === -1) sortedRows = reverse(sortedRows);
      this.setState({sortedRows});
    }
  }

  setRef = ref => {
    this.grid = ref;
  }

  cashSummaryDetails = async (positionObjId, e) => {
    if(isEnterorSpaceKeyPressed(e)){
      if(!this.props.payments.isCashPaymentFlow)   //WMCE-47749-To avoid cash account screen in between of payment flow due to asyncronous behaviour 
      {
        await this.props.setPositionObjId(positionObjId);
        this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_DETAILS_ROUTE);
        await this.props.cashAccounts.getRTCashAccList(positionObjId);
      }
    }
  }

  toggleSorted = (columnIndex, e) => {
    if(isEnterorSpaceKeyPressed(e)){
      const order = [1, -1, 0];
      const sortedColumnIndex = columnIndex;
      let sortedDirection = order[0];
      if (sortedColumnIndex === this.state.sortedColumnIndex) {
        let next = order.indexOf(this.state.sortedDirection) + 1;
        if (next >= order.length) next = 0;
        sortedDirection = order[next];
      }
      const sortColumn = this.getColumnByIndex(sortedColumnIndex);
      let sortedRows = (sortColumn && sortedDirection !== 0) ? sortBy(this.state.sortedRows, sortColumn) : this.state.sortedRows;
      if (sortedDirection === -1) sortedRows = reverse(sortedRows);
      if (sortedDirection === 0) sortedRows = this.props.cashAccSummary.cashAccList;
      this.setState({
        sortedColumnIndex,
        sortedDirection,
        sortedRows
      });
    }
  }

  /* Rendering each header cell (row 0 ) */
  renderHeaderCell = ({ columnIndex, messages }) => {
    const sorted = (columnIndex === this.state.sortedColumnIndex) ? this.state.sortedDirection : 0;
    let upArrowColor = PALETTE.loginFooterText;
    let downArrowColor = PALETTE.loginFooterText;
    if (sorted === -1) {
      upArrowColor = PALETTE.loginFooterText;
      downArrowColor = PALETTE.primaryActive;
    } else if (sorted === 1) {
      upArrowColor = PALETTE.primaryActive;
      downArrowColor = PALETTE.loginFooterText;
    }
   // if (columnIndex !== 5) {
      return (
        <div className="cashHeader_container">
          <div className="cashSorting_container">
            <Text size={"big"} secondary className={columnIndex === 5 ? 'listHeaderText alignSelf' : 'listHeaderText'} tabIndex={SUMMARY_LIST_COLUMNS[columnIndex].columnLabel ? 0 : -1}>{messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]}</Text>
          </div>
          {columnIndex === 5 &&
            <Popover
              mode="popup"
              orientation="top"
              showOnHover
              popOverClassName="cur-bal-popover"
              arrowColor={PALETTE.secondaryActive}
              content={<div>{messages["app.cashAccounts.summary.curBalPopoverContent"]}</div>}
            >
              <div aria-label={messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]+ " " + messages['app.cashAccounts.informationIcon']+ " " + messages["app.cashAccounts.summary.curBalPopoverContent"]}>
                <Info2 color={PALETTE.primaryText} height={29} width={29}/>
              </div>
            </Popover>
          }
          {columnIndex !== 6 && columnIndex!==7 ?
            <Sort tabIndex={0} aria-label={messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel] + " " + messages['app.assets.sortHeader']} role="button" className="cashSorting_icon" width={20} height={20} color={PALETTE.primaryText} upArrowColor={upArrowColor} downArrowColor={downArrowColor} />
            : ''}
         
        </div>
      );
   // }
    // else {
    //   return (
    //     <div className="cashHeader_container">
    //       <div className="cashSorting_container">
    //         <Text className='listMktHeaderText'> {messages[SUMMARY_LIST_COLUMNS[columnIndex].columnLabel]}</Text>
    //         <Text className="listMktSubHeaderText">
    //           <FormattedMessage
    //             id={SUMMARY_LIST_COLUMNS[columnIndex].subHead}
    //             values={{prefCurrency: this.props.cashAccounts.destinationCcy}}
    //           />
    //         </Text>
    //       </div>
    //       <div className="cashMktValIcons">
    //         <Popover
    //           mode="popup"
    //           orientation="top"
    //           showOnHover
    //           popOverClassName="mkt-val-popover"
    //           arrowColor={PALETTE.secondaryActive}
    //           content={<div>{messages["app.dashboard.summaryData.popover.content"]}</div>}
    //         >
    //           <Info2 color={PALETTE.fordGray} height={29} width={29}/>
    //         </Popover>
    //         <Sort className="cashSorting_icon" width={20} height={20} color={PALETTE.primaryText} upArrowColor={upArrowColor} downArrowColor={downArrowColor} />
    //       </div>
    //     </div>
    //   );
    // }
  }

  /* For rendering the data for each cell */
  renderDataCell = ({ columnIndex, row, rowIndex }) => {
    const { i18n: { messages }} = this.props;
    const column = this.getColumnByIndex(columnIndex);
    if (!row || !column) return null;
    if (column === CASH_ACCOUNTS_CONSTANTS.BALANCE) {
      return (
        <div tabIndex={0} onKeyDown={(e) => { this.cashSummaryDetails(this.state.sortedRows[rowIndex - 1].positionObjId, e ) }}>
          <Currency
            signBeforeNumber={true}
            decimalStyle={styles.decimalStyle}
            renderProps={{
              style: styles.marketValueText,
            }}
            currencyStyle={styles.decimalStyle}
            value={row[column]}
            currency={row[CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNT_CURRENCY]}     //WMCE-47749-Adding Currency with Current Balance - <Cash Account Currency> <Amount> 
          />
        </div>
      );
    }
    if (column === CASH_ACCOUNTS_CONSTANTS.ARROW) {
      return (
        <span className={'pointer'} onKeyDown={(e) => { this.cashSummaryDetails(this.state.sortedRows[rowIndex - 1].positionObjId, e ) }}>
          <ArrowRight tabIndex={0} aria-label={messages['app.faq.viewDetails']} width={10} height={20} color={this.state.selectedRowIndex === rowIndex ? PALETTE.primaryActive : PALETTE.secondaryText} />
        </span>
 
      );
    }
    if (column === CASH_ACCOUNTS_CONSTANTS.NEW_PAYMENT) {
      return (
        <div>
        <View className={'pointer'}>
          <PaymentSelection pageName="cashposition-page" psPosId={this.state.sortedRows[rowIndex - 1].positionObjId} />
        </View>
        </div>

      );
   }
    return (
      <Text size="large" tabIndex={0} aria-label={column === "pfId" ? labelForPFid(row[column]) : row[column]} onKeyDown={(e) => { this.cashSummaryDetails(this.state.sortedRows[rowIndex - 1].positionObjId, e ) }}>
        {row[column]}
      </Text>);
  }

  getColumnByIndex = (columnIndex) => {
    if (columnIndex === -1) {
      return 'summary';
    }
    return SUMMARY_LIST_COLUMNS[columnIndex].columnValue;
  }

  setSelectedRowIndex = (rowIndex) => {
    this.setState({selectedRowIndex: rowIndex})
  }

  resetSelectedRowIndex = () => {
    this.setState({selectedRowIndex: -1})
  }
  /* To render data for summary list */
  renderCell = ({ rowIndex, columnIndex, gridRowIndex, gridColumnIndex }) => {
    const { i18n: { messages }, cashAccSummary } = this.props;
    if (rowIndex === 0) {
      return (
        <Cell
          {...{ gridRowIndex, gridColumnIndex }}
          header
          sortable
          onKeyDown={(columnIndex !== 6 && columnIndex !== 7)? (e) => this.toggleSorted(columnIndex, e) : null}
          className={columnIndex < 4 ? "cashSummaryGrid_header_cell" : ((columnIndex === 5 || columnIndex === 4) ? "cashSummaryGrid_header_cell cashSummaryGrid_content_mv" : "cashSummaryGrid_header_cell")}
          role="grid"
        >
          <div onClick={(columnIndex !== 6 && columnIndex !== 7)? () => this.toggleSorted(columnIndex) : null}>
            {this.renderHeaderCell({ columnIndex, messages })}
          </div>
        </Cell>
      );
    }
    if(!cashAccSummary.hasMore && Array.isArray(cashAccSummary.cashAccList)){
      return (
        <Cell onClick={() => { this.cashSummaryDetails(this.state.sortedRows[rowIndex - 1].positionObjId ) }} 
          onMouseEnter={()=>this.setSelectedRowIndex(rowIndex)} onMouseLeave={this.resetSelectedRowIndex}
          {...{ gridRowIndex, gridColumnIndex }}
          className={columnIndex < 4 ? "cashSummaryGrid_content_cell"
            : ((columnIndex === 4 || columnIndex === 5) ? "cashSummaryGrid_content_cell cashSummaryGrid_content_mv" : "cashSummaryGrid_content_cell cashSummaryGrid_content_center")}
            role="grid"
        >
           <span>
          {this.renderDataCell({ columnIndex, row: this.state.sortedRows[rowIndex - 1], rowIndex })}
          </span>
        </Cell> 
      );
    }
  }

  rowHeight = () => 68;

  columnWidth({ index }) {
    let widthsInPercentage = ['20%', '18%','14%', '10%', '8.5%', '14.5%', '4%','10%'];
    const columnWidth = widthsInPercentage[index];
    return columnWidth;
  }


  render() {
    const { cashAccSummary, i18n: { messages } } = this.props;
    const totalData = cashAccSummary.cashAccList ? cashAccSummary.cashAccList.length : 0;
    let classname = totalData<7 ? "cashSummaryGrid_"+totalData : (cashAccSummary.hasMore ? "cashSummaryGrid_0" : "cashSummaryGrid_7");

    return (
      <div className={`${"cashSummaryGrid"}${cashAccSummary.hasMore ? " cashSummaryGrid_7" : ''}${(this.props.showCashAccBanner || (!cashAccSummary.cashAccList) || (cashAccSummary.cashAccList.length <=0) ) ? " margin-top" : ""}`}>
        <div className={classname}>
          <Grid
            ref={this.setRef}
            classNameBottom="cashSummary__bottomBorder"
            classNameTop="cashSummary__topGrid"
            classNameMain="cashSummary__mainGrid"
            rowCount={totalData + 1}
            stickyTopRowCount={1}
            rowHeight={this.rowHeight}
            columnCount={8}
            columnWidth={this.columnWidth}
            renderCell={this.renderCell}
            role="grid"
          />
        </div>
        { (cashAccSummary.hasMore || !cashAccSummary.cashAccList || !totalData) &&
          <div tabIndex={0} className="currencyChartNoData"><Text>{this.props.i18n.messages['app.manageContactDetails.noData']}</Text></div> }
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    userprofile: {
      prefCurrency: true
    },
    app: {
      user: {
        portfolios: true,
        portfolioSelection : { $call: 'portfolioSelection' }
      }
    },
    setPositionObjId: { $set: 'cashAccounts.positionObjId' },
    cashAccounts :{
      getRTCashAccList: { $call: 'getRTCashAccList' },
      destinationCcy: true
    },
    payments: {
      isCashPaymentFlow: true,
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
    },
  },
})(SummaryCashAccountsGrid);

